export function WarRoomBackground({ children }: { children: React.ReactNode }) {
  return (
    <div className="relative min-h-screen">
      {/* Layer 1: Base color — applied via body bg */}
      {/* Layer 2: Radial gradient blue light pool from top center */}
      <div
        className="fixed inset-0 pointer-events-none z-0"
        style={{
          background:
            "radial-gradient(ellipse 60% 40% at 50% 0%, rgba(75,117,242,0.07) 0%, transparent 70%)",
        }}
      />
      {/* Layer 3: CSS noise texture at 2-3% opacity */}
      <div
        className="fixed inset-0 pointer-events-none z-0 opacity-[0.025]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='1'/%3E%3C/svg%3E")`,
          backgroundRepeat: "repeat",
          backgroundSize: "256px 256px",
        }}
      />
      {/* Layer 4: Scattered particle dots */}
      <svg
        className="fixed inset-0 w-full h-full pointer-events-none z-0 opacity-[0.15]"
        xmlns="http://www.w3.org/2000/svg"
      >
        {Array.from({ length: 40 }, (_, i) => (
          <circle
            key={i}
            cx={`${((i * 37 + 13) % 97) + 1}%`}
            cy={`${((i * 53 + 7) % 89) + 3}%`}
            r={Math.random() > 0.7 ? 1.5 : 1}
            fill="rgba(255,255,255,0.3)"
          />
        ))}
      </svg>
      {/* Layer 5: Subtle grid lines */}
      <div
        className="fixed inset-0 pointer-events-none z-0 opacity-[0.015]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.15) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.15) 1px, transparent 1px)",
          backgroundSize: "60px 60px",
        }}
      />
      {/* Content */}
      <div className="relative z-10">{children}</div>
    </div>
  );
}
